import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import Mixpanel from "mixpanel-browser";
import { verifyEmail } from "../../features/auth/verify-email/verifyEmailSlice";

const VerifyEmailModal = ({ isOpen, toggle }) => {
  const [message, setMessage] = useState("");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dispatch = useDispatch();

  const verifyEmailId = async (verifyEmailToken) => {
    Mixpanel.track("Email verification checked", {
      Page: "Verification email page",
    });
    const { payload } = await dispatch(verifyEmail(verifyEmailToken));
    setMessage(
      payload?.data?.responseMessage || payload?.response?.data?.responseMessage
    );
  };

  useEffect(() => {
    const verifyEmailToken = searchParams.get("email_verify");
    verifyEmailId(verifyEmailToken);
  }, []);

  return (
    <div>
      <Modal
        className="add-document-popup update-password"
        show={isOpen}
        onHide={toggle}
        backdrop="static"
        // modalTransition={{ timeout: 2000 }}
        dialogClassName="common-modal"
        centered={true}
      >
        <Modal.Header>
          <h3 className="modal-title" id="Add_OrganizationLabel">
            Email Verification
          </h3>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={toggle}
          ></button>
        </Modal.Header>
        <Modal.Body>{message && <p>{message}</p>}</Modal.Body>
        <Modal.Footer>
          <Button variant="btn btn-primary-md" onClick={toggle}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default VerifyEmailModal;
